// extracted by mini-css-extract-plugin
export default {"PostCreate":"qk_a bhs_qt bhs_a bhs_w bhs_ea"};